import React, { useState } from 'react';
import {
    CognitoUser,
    CognitoUserAttribute,
    CognitoUserPool,
} from 'amazon-cognito-identity-js';
import { CLIENT_ID, USER_POOL_ID } from '../__common/env';

export default function useUserSignUp() {
    const [isLoading, setIsLoading] = useState(false);
    const poolData = {
        UserPoolId: USER_POOL_ID,
        ClientId: CLIENT_ID,
    };
    const signUpWithCognito = (user) => {
        return new Promise((resolve, reject) => {
            setIsLoading(true);
            const userPool = new CognitoUserPool(poolData);

            const attributeList = [
                new CognitoUserAttribute({ Name: 'email', Value: user.email }),
                new CognitoUserAttribute({
                    Name: 'name',
                    Value: user.firstName + ' ' + user.lastName,
                }),
                new CognitoUserAttribute({
                    Name: 'given_name',
                    Value: user.firstName,
                }),
                new CognitoUserAttribute({
                    Name: 'family_name',
                    Value: user.lastName,
                }),
            ];

            userPool.signUp(
                user.email,
                user.password,
                attributeList,
                null,
                (err, result) => {
                    setIsLoading(false);
                    if (err) {
                        reject(err);
                        return;
                    }
                    resolve(result);
                },
            );
        });
    };

    const verifyCode = (userName, code) => {
        return new Promise((resolve, reject) => {
            setIsLoading(true);
            const userPool = new CognitoUserPool(poolData);
            const cognitoUser = new CognitoUser({
                Username: userName,
                Pool: userPool,
            });

            if (!cognitoUser) {
                reject('User not found!');
                return;
            }

            cognitoUser.confirmRegistration(code, true, (err, result) => {
                setIsLoading(false);
                if (err) {
                    reject(err);
                    return;
                }
                resolve(result);
            });
        });
    };
    const resendVerificationCode = (inUserName) => {
        return new Promise((resolve, reject) => {
            const userPool = new CognitoUserPool(poolData);

            const cognitoUser = new CognitoUser({
                Username: inUserName,
                Pool: userPool,
            });
            if (!cognitoUser) {
                reject('User not found!');
                return;
            }
            cognitoUser.resendConfirmationCode((err, result) => {
                if (err) {
                    reject(err);
                    return;
                }
                resolve(result);
            });
        });
    };
    return { signUpWithCognito, verifyCode, isLoading, resendVerificationCode };
}
